<template>
  <div>
    <Message v-if="!!serveTip">
      {{ serveTip }}
    </Message>
    <Message v-else-if="info && info.online && info.showMaintenance && !onMaintenance">{{
      $t("message.Booking.maintenanceMessageBefore", [
        formatMaintenanceStartTime,
        formatMaintenanceEndTime,
        message,
      ])
    }}</Message>
    <slot v-if="info && info.online && !onMaintenance"></slot>
    <Result
      v-else-if="info && info.online && onMaintenance"
      :title="$t('message.Booking.maintenanceTitle')"
      :message="
        $t('message.Booking.maintenanceMessage', [
          formatMaintenanceStartTime,
          formatMaintenanceEndTime,
          message,
        ])
      "
    >
      <template slot="icon">
        <i class="el-icon-setting" style="color: #fe6c6f"></i>
      </template>
    </Result>
    <Result
      v-else-if="info && !info.online && info.onlineEndTime"
      :title="$t('message.Booking.maintenanceTitle')"
      :message="$t('message.Booking.maintenanceMessageOffShelf')"
    >
      <template slot="icon">
        <i class="el-icon-warning-outline" style="color: #fe6c6f"></i>
      </template>
    </Result>
  </div>
</template>
<script>
import Result from "../../../components/Result";
import Message from "../../../components/Message";
export default {
  components: { Message, Result },
  props: {
    info: {
      type: Object,
    },
    serveTip: String
  },
  computed: {
    formatMaintenanceStartTime() {
      return (
        this.info &&
        this.info.maintenanceStartTime &&
        this.$formatDate(this.info.maintenanceStartTime)
      );
    },
    formatMaintenanceEndTime() {
      return (
        this.info &&
        this.info.maintenanceEndTime &&
        this.$formatDate(this.info.maintenanceEndTime)
      );
    },
    message() {
      return this.info && this.info[`message${this.$t("message.lan")}`];
    },
    // 維護中
    onMaintenance() {
      const value = this.info;
      if (!value) return false;
      const date = new Date().getTime();
      const maintenanceStartTime = value.maintenanceStartTime
        ? new Date(value.maintenanceStartTime).getTime()
        : null;
      const maintenanceEndTime = value.maintenanceEndTime
        ? new Date(value.maintenanceEndTime).getTime()
        : null;
      return (
        maintenanceStartTime &&
        (date >= maintenanceStartTime && date <= maintenanceEndTime)
      );
    },
  },
};
</script>
